var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pr-DeliveryDateCtrl"},[_c('div',{staticClass:"pr-EstimatePrice_DeliveryCtrl",on:{"click":_vm.openModal}},[_c('i',{staticClass:"ka ka-calendar pr-EstimatePrice_CalendarIcon"}),_vm._v(" "),_c('span',{staticClass:"pr-EstimatePrice_CalendarLabel"},[_vm._v("\n      お届け日を確認\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }